export const CORTAD_VARIABLES = [
  { id: 'sst', label: 'SST', unit: '°C' },
  { id: 'ssta', label: 'SST anomaly', unit: '°C' },
  { id: 'tsa', label: 'Thermal stress', unit: '°C' },
  { id: 'tsa_dhw', label: 'Degree Heating Weeks', unit: '°C-weeks' },
  { id: 'ssta_dhw', label: 'SSTA Degree Heating Weeks', unit: '°C-weeks' },
];

export const CORTAD_PRIMARY_VARIABLES = ['sst', 'ssta', 'tsa', 'tsa_dhw'];
export const DEFAULT_CORTAD_VARIABLE = 'tsa_dhw';
export const DEFAULT_CORTAD_MONTH = '2016-08';
export const CORTAD_MIN_ZOOM = 3;
export const CORTAD_MAX_ZOOM = 7;

export const cortadTileUrl = (variable, month) => (
  `/api/public/cortad-tiles/${variable}/${month}/{z}/{x}/{y}.png`
);

export const formatCortadMonth = (yyyymm) => {
  if (!yyyymm || yyyymm.length < 7) return yyyymm || '';
  const year = yyyymm.slice(0, 4);
  const month = Number(yyyymm.slice(5, 7));
  const names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return `${names[month - 1] || yyyymm} ${year}`;
};

export const pickDefaultMonth = (months = []) => {
  if (!months.length) return '';
  if (months.includes(DEFAULT_CORTAD_MONTH)) return DEFAULT_CORTAD_MONTH;
  const year2016 = months.filter((item) => item.startsWith('2016'));
  if (year2016.length) return year2016[Math.min(7, year2016.length - 1)];
  return months[months.length - 1];
};
